import React, { useState, useEffect, useRef } from "react";
import logo from '../../images/vanani_logo.svg';
import { Link, useLocation, useNavigate } from "react-router-dom";

function Navbar() {
  const [activeDropdown, setActiveDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const location = useLocation();
  const navigate = useNavigate();

  const toggleDropdown = () => {
    setActiveDropdown((prev) => !prev);
  };

  const closeDropdown = () => {
    setActiveDropdown(false);
  };

  const handleScroll = (e) => {
    e.preventDefault();
    const targetId = e.target.getAttribute("href").slice(1);
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleLogoClick = () => {
    if (location.pathname === "/") {
      window.scrollTo(0, 0);
    } else {
      navigate("/");
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="header_main_wrap">
      <div className="container">
        <div className="inr_header_wrap row align-items-center">
        <div className="col-lg-4 col-md-4">
            <img
                  src={logo}
                  alt="Vanani Associated"
                  onClick={handleLogoClick}
                  style={{ cursor: 'pointer' }}
                />
        </div>
          <div className="col-lg-8 col-md-8 align-right">
            <div className="nav_wrapper d-flex justify-content-end align-items-center">
              <ul className="d-flex justify-content-end">
                <li><Link to="/about">About Us</Link></li>
                <li
                  ref={dropdownRef}
                  className={`dropdown ${activeDropdown ? "active" : ""}`}
                >
                  <Link to="/Services" onClick={toggleDropdown}>
                    Services <i className="fas fa-chevron-down"></i>
                  </Link>
                  {/* <ul className={`drop_down ${activeDropdown ? "show" : ""}`}> */}
                  <ul className='first_drop_down'>
                    <li><Link to="/incorporation">Incorporation</Link> <i class="fas fa-chevron-right"></i>
                      <ul className='second_drop_down'>
                        <li><Link to="/sole-proprietorship">Sole Proprietorship</Link></li>
                        <li><Link to="/partnership-firm">Partnership Firm</Link></li>
                        <li><Link to="/limited-liability">Limited Liability Partnership (LLP)</Link></li>
                        <li><Link to="/one-person-company">One Person Company</Link></li>
                        <li><Link to="/private-limited-company">Private Limited Company</Link></li>
                        <li><Link to="/public-limited-company">Public Limited Company</Link></li>
                      </ul>
                    </li>
                    <li><Link to="/accounting">Accounting</Link></li>
                    <li><Link to="/Taxation">Taxation</Link><i class="fas fa-chevron-right"></i>
                        <ul className='second_drop_down'>
                          <li><Link to="/direct-tax-services">Direct Tax Services</Link></li>
                          <li><Link to="/indirect-tax-service">Indirect Tax Service</Link></li>
                        </ul>
                    </li>
                    <li><Link to="/specialized_tax-services">Specialized Tax Services</Link></li>
                    <li><Link to="/audit-and-assurance-services">Audit & Assurance</Link></li>
                    <li><Link to="/consultancy-services">Consultancy Service</Link></li>
                    <li><Link to="/">Corporate Compliance</Link></li>
                    <li><Link to="/">CFO Services</Link></li>
                    <li><Link to="/">Outsourcing</Link></li>
                  </ul>
                </li>
                <li className="dropdown"><Link to="/">Industries <i className="fas fa-chevron-down"></i></Link>
                <ul className='first_drop_down'>
                    <li><Link to="/">Real Estate & Infrastructure</Link></li>
                    <li><Link to="/">Manufacturing</Link></li>
                    <li><Link to="/">Taxtile</Link></li>
                    <li><Link to="/">Engineering & Consultancy</Link></li>
                  </ul>
                </li> 
                <li><Link to="/">Query</Link></li>
                <li><Link to="/">Careers</Link></li>
                <li><Link to="/Blogs">Blogs</Link></li>
              </ul>
              <div className="right_btn_Wrap">
                <Link
                    className="rounded-pill btn solid_btn"
                    to="/#contact-us-wrapper"
                  >
                    Contact Us <i className="fas fa-chevron-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Navbar;
